import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IAffiliateProfileSubaffiliatePayload } from '../types';
import {
  AFFILIATE_PROFILE_SUBAFFILIATE_API_URL,
  AFFILIATE_PROFILE_SUBAFFILIATE_MUTATION,
  AFFILIATES_APPROVED_PROFILE_PERMISSIONS,
} from '../constants';

export default function useAffiliateProfileSubaffiliateMutation(): IContextMutationResult<void, Error, IAffiliateProfileSubaffiliatePayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IAffiliateProfileSubaffiliatePayload>({
    mutationKey: [AFFILIATE_PROFILE_SUBAFFILIATE_MUTATION],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      AFFILIATE_PROFILE_SUBAFFILIATE_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_PROFILE_PERMISSIONS.INVITATIONS_EDIT,
        urlParams: {
          id,
        },
      },
    ),
  });
}
